import { tableNameOptions } from "../../../utils/mics";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { useFormik } from "formik";
import appActions from "../../../appActions";
import { useDispatch } from "react-redux";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

const CleanUpTable = () => {
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            dateFrom: '',
            tableName: null,
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                dateFrom: values.dateFrom ? moment(values.dateFrom).format('YYYY-MM-DD') : '',
            };

            dispatch(appActions.EXPORTLOGS_CLEAN_UP_TABLE_REQUEST(data));
        },
    });

    const handleClear = () => {
        formik.resetForm();
    };

    const renderHeader = () => (
        <div className="col-12">
            <h1 className="page-header flex">Clean Up Table</h1>
        </div>
    );

    const renderList = () => (
        <>
            <div className="grid px-4 align-items-center my-2">{renderHeader()}</div>

            <div className="bg-white mx-4 pv-20 ph-20 br-6 shadow-white">
                <>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid p-2">
                            <div className="p-fluid formgrid grid w-full">
                                <div className="field col-12 md:col-4">
                                    <label htmlFor="tableName">Table Name</label>
                                    <Dropdown showClear 
                                        placeholder="Select Table Name"
                                        value={formik.values.tableName}
                                        onChange={(e) =>
                                            formik.setFieldValue("tableName", e.value)
                                        }
                                        options={tableNameOptions}
                                        id="tableName"
                                        name="tableName"
                                        optionLabel="name"
                                        optionValue="code"
                                    />
                                </div>

                                <div className="field col-12 md:col-3">
                                    <label htmlFor="dateFrom">Date From</label>
                                    <Calendar
                                        id="dateFrom"
                                        name="dateFrom"
                                        value={formik.values.dateFrom}
                                        onChange={(e) =>
                                            formik.setFieldValue("dateFrom", e.value)
                                        }
                                        dateFormat="dd-mm-yy"
                                        showIcon
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid px-2 py-4 flex-row-reverse gap-10">
                                <Button type="submit" icon="pi pi-search" label="Submit" severity="success" outlined className="p-button-success mr-2" />
                                <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset" label="Reset" severity="secondary" outlined onClick={handleClear} />
                        </div>
                    </form>
                </>
            </div>
        </>
    );

    return <div className="form_height">{renderList()}</div>;
};

export default CleanUpTable;